import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateControlAssignmentsForUserMutation } from "org/user/queries/useUpdateControlAssignmentsForUserMutation";

import { buildPatchAssignmentBody } from "./buildPatchAssignmentBody";
import { ControlRow } from "./useUserAssignedControlListTable";

interface UseRemoveControlAssignmentUtilsProps {
    userId: number;
    selectedRows: Row<ControlRow>[];
    deselectAll: () => void;
}

export function useRemoveControlAssignmentUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemoveControlAssignmentUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate, isPending, error, reset } =
        useUpdateControlAssignmentsForUserMutation(userId);

    const removeAccessRightToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeAccessRight = () => {
        mutate(buildPatchAssignmentBody(selectedRows, null), {
            onSuccess: () => {
                deselectAll();
                setIsModalOpen(false);
            },
            // On failure the modal stays open; `error` drives the inline notice.
        });
    };

    return {
        removeAccessRightToolState,
        isRemoveAccessRightModalOpen: isModalOpen,
        removeAccessRightError: error,
        // Reset on open (not close) so the notice stays put during the close
        // animation and a stale error can't reappear next time.
        openRemoveAccessRightModal: () => {
            reset();
            setIsModalOpen(true);
        },
        closeRemoveAccessRightModal: () => setIsModalOpen(false),
        removeAccessRight,
        isRemovingAccessRight: isPending,
    };
}
